import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import i18n from 'i18n';
import Dropdown from 'components/Dropdown';
import { stringCompare } from 'lib/view-helpers';
import { PRODUCTS_SORT_OPTIONS } from '../constants';

const ALL_RETAILERS = { id: 0, name: i18n.t('ALL_RETAILERS') };

const propTypes = {
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func
};

/**
 * Retailer filter
 */

function Retailers({ options, selected, onSelect }) {
  const retailer = selected
    ? options.reduce((res, r) => {
        if (stringCompare(r.id, selected)) res = r;
        return res;
      }, {})
    : ALL_RETAILERS;
  return (
    <StyledFilters>
      <div className="small text-muted">{i18n.t('FILTER_ON')}</div>
      <Dropdown
        title={retailer.name || i18n.t('SUPERMARKET')}
        items={[ALL_RETAILERS].concat(options)}
        selected={selected}
        onSelect={onSelect}
        color="outline-primary"
      />
    </StyledFilters>
  );
}

Retailers.propTypes = {
  ...propTypes
};

Retailers.defaultProps = {
  onSelect: () => {}
};

function Sort({ options, selected, onSelect }) {
  return (
    <StyledFilters>
      <div className="small text-muted">{i18n.t('SORT_ON')}</div>
      <Dropdown
        title={
          (selected && i18n.t(`${selected.toUpperCase()}`)) || i18n.t('SORT_ON')
        }
        items={options.map((option) => ({
          name: i18n.t(option.toUpperCase()),
          id: option
        }))}
        selected={selected}
        onSelect={onSelect}
        color="outline-primary"
      />
    </StyledFilters>
  );
}

Sort.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOf(Object.keys(PRODUCTS_SORT_OPTIONS))
  ).isRequired,
  ...propTypes
};

Sort.defaultProps = {
  options: [],
  onSelect: () => {}
};

export default {
  Retailers,
  Sort
};

const StyledFilters = styled.div`
  margin: 15px 0;
`;
